import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import broadcastService from "services/admin/broadcastService";
import { snack } from "components/Snack/Snack";
import { useForm } from "react-hook-form";
import { Button, TextField } from "@mui/material";

const BroadcastForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { broadcast },
}: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      name: broadcast?.name,
      textVariants: broadcast ? broadcast.textVariants || [] : [],
    },
  });

  const onSubmit = async (formValues: any) => {
    try {
      if (broadcast) {
        await broadcastService.put(id, formValues);
        snack("Рассылка обновлена успешно!");
      } else {
        await broadcastService.post(formValues);
        snack("Рассылка создана успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={broadcast ? "Редактирование рассылок" : "Создание рассылок"}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="m-b-16">
          <TextField
            fullWidth
            label="Название рассылки"
            type="text"
            id="name"
            {...register("name")}
            required
          />
        </div>
        <div className="m-b-16">
          {watch("textVariants")?.map((textVariant: any, index: number) => (
            <div key={index} className="mb-8">
              <TextField
                key={index}
                fullWidth
                label={`Текст варианта ${index + 1}`}
                type="text"
                id="textVariants"
                multiline
                minRows={4}
                {...register(`textVariants.${index}`)}
              />
            </div>
          ))}
          <Button
            variant="contained"
            type="button"
            onClick={() => {
              const textVariants = watch("textVariants");
              textVariants.push("");
              setValue("textVariants", textVariants);
            }}
          >
            Добавить вариант
          </Button>
        </div>
        <Button variant="contained" type="submit">
          Сохранить
        </Button>
      </form>
      <pre>{JSON.stringify(watch(), null, 2)}</pre>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(BroadcastForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["broadcast"] = () => broadcastService.get(router.params.id);
    }
    return useLoadAll(requests);
  })
);
